import { configureStoreDev } from './configureStore.dev';
import { configureStoreProd } from './configureStore.prod';

export const configureStore = () => {
  if (process.env.REACT_APP_ENABLE_REDUX_LOG === 'true') {
    return configureStoreDev();
  } else {
    return configureStoreProd();
  }
};
